// extracted by mini-css-extract-plugin
module.exports = {"Forms":"DealCardModalForm_Forms__nFFya"};